import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Headphones } from "lucide-react";

export default function NowPlaying({ variant = "inline" }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await api.get("/now-playing");
        if (!cancelled) setData(data);
      } catch { /* ignore */ }
    };
    load();
    const t = setInterval(load, 30000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (!data || data.active_listeners === 0) return null;
  const count = data.active_listeners;
  const top = data.top_episode;

  if (variant === "pill") {
    return (
      <div className="inline-flex items-center gap-2 bg-coal border border-hotpink/40 px-3 py-1.5 text-xs font-outfit" data-testid="now-playing-pill">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full rounded-full bg-hotpink opacity-75 animate-ping" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-hotpink" />
        </span>
        <span className="text-white">
          <span className="text-hotpink font-bold">{count}</span> listening now
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 bg-coal border border-hotpink/40 px-4 py-3" data-testid="now-playing-banner">
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-hotpink opacity-75 animate-ping" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-hotpink" />
      </span>
      <Headphones size={16} className="text-hotpink" />
      <div className="flex-1 min-w-0">
        <p className="font-outfit text-sm text-white">
          <span className="text-hotpink font-extrabold">{count}</span> {count === 1 ? "person is" : "people are"} listening right now
        </p>
        {top && (
          <p className="scribble text-hotpink text-base leading-tight truncate">tonight's favorite: Ep {String(top.number).padStart(2, "0")} · {top.title}</p>
        )}
      </div>
    </div>
  );
}
